export default "./dist/stdassets/images/icons/pan-north.png";